import React from 'react';
import { Star, ArrowRight, UtensilsCrossed, ChefHat } from 'lucide-react';
import { Link } from 'react-router-dom';

// Professional food photoshoot images - All 10 dishes
const FOOD_PHOTOS = {
  chicharron: "https://customer-assets.emergentagent.com/job_045563bf-4bdb-48a2-991f-697b1fca894b/artifacts/hthspvyj_Chicharro%CC%81n.jpg",
  chickenTacos: "https://customer-assets.emergentagent.com/job_045563bf-4bdb-48a2-991f-697b1fca894b/artifacts/nppzerfn_Chicken%20Tacos.jpg",
  patatasBravas: "https://customer-assets.emergentagent.com/job_045563bf-4bdb-48a2-991f-697b1fca894b/artifacts/mkm7u8jw_Patatas%20Bravas.jpg",
  taquitos: "https://customer-assets.emergentagent.com/job_045563bf-4bdb-48a2-991f-697b1fca894b/artifacts/8fi8nnbz_Taquitos.jpg",
  chipotlePaneerBurrito: "https://customer-assets.emergentagent.com/job_045563bf-4bdb-48a2-991f-697b1fca894b/artifacts/vh8qredt_Chipotle%20Paneer%20Burrito.jpg",
  texMexNachos: "https://customer-assets.emergentagent.com/job_045563bf-4bdb-48a2-991f-697b1fca894b/artifacts/durdbnx1_Tex%20Mex%20Chicken%20Nachos.jpg",
  chickenFajitas: "https://customer-assets.emergentagent.com/job_045563bf-4bdb-48a2-991f-697b1fca894b/artifacts/x6zxb47k_Chicken%20Fajitas.jpg",
  chipotlePaneerBurrito2: "https://customer-assets.emergentagent.com/job_045563bf-4bdb-48a2-991f-697b1fca894b/artifacts/8bj2pqgy_Chipotle%20Paneer%20Burrito.jpg",
  enchiladas: "https://customer-assets.emergentagent.com/job_045563bf-4bdb-48a2-991f-697b1fca894b/artifacts/9oip3hws_Enchiladas%281%29.jpg",
  churros: "https://customer-assets.emergentagent.com/job_045563bf-4bdb-48a2-991f-697b1fca894b/artifacts/mar8qk2z_Churros.jpg",
  tasteOfMexico: "https://customer-assets.emergentagent.com/job_045563bf-4bdb-48a2-991f-697b1fca894b/artifacts/c3jodrna_WhatsApp%20Image%202026-04-15%20at%2018.24.46.jpeg"
};

// Chef's Special items - now with ALL real professional photos
const signatureDishes = [
  {
    name: "Chicken Tacos",
    description: "Fresh-made tortillas with tender chicken, pickled onions & our signature salsas",
    image: FOOD_PHOTOS.chickenTacos,
    tag: "Tacos",
    price: 275,
    isVeg: false
  },
  {
    name: "Patatas Bravas",
    description: "Crispy spiced potatoes with cotija cheese, chipotle sauce & salsa verde",
    image: FOOD_PHOTOS.patatasBravas,
    tag: "Starters",
    price: 320,
    isVeg: true
  },
  {
    name: "Taquitos",
    description: "Crispy rolled tortillas with spiced filling, guacamole drizzle & pickled onions",
    image: FOOD_PHOTOS.taquitos,
    tag: "Starters",
    price: 475,
    isVeg: false
  },
  {
    name: "Paneer Chipotle Burrito",
    description: "Soft tortilla packed with smoky chipotle paneer, rice, beans & fresh guacamole",
    image: FOOD_PHOTOS.chipotlePaneerBurrito,
    tag: "Burritos",
    price: 575,
    isVeg: true
  },
  {
    name: "Tex Mex Chicken Nachos",
    description: "Loaded tortilla chips with Tex Mex chicken, melted cheese, guacamole & sour cream",
    image: FOOD_PHOTOS.texMexNachos,
    tag: "Nachos",
    price: 625,
    isVeg: false
  },
  {
    name: "Chicken Fajitas",
    description: "Sizzling grilled chicken with peppers, onions, warm tortillas & signature sauces",
    image: FOOD_PHOTOS.chickenFajitas,
    tag: "Fajitas",
    price: 695,
    isVeg: false
  },
  {
    name: "Lamb Birria Enchiladas",
    description: "Hand-rolled enchiladas with slow-cooked lamb, rice, beans, guacamole & pico de gallo",
    image: FOOD_PHOTOS.enchiladas,
    tag: "Enchiladas",
    price: 775,
    isVeg: false
  },
  {
    name: "Paneer Burrito",
    description: "Griddled burrito with chipotle paneer, guacamole & pickled onions",
    image: FOOD_PHOTOS.chipotlePaneerBurrito2,
    tag: "Burritos",
    price: 575,
    isVeg: true
  },
  {
    name: "Churros",
    description: "Cinnamon-sugar dusted churros served with rich Mexican chocolate dipping sauce",
    image: FOOD_PHOTOS.churros,
    tag: "Dessert",
    price: 225,
    isVeg: true
  },
  {
    name: "Taste of Mexico",
    description: "The ultimate shared platter - Birria, Carnitas, Tinga, Mexican rice, elote, guacamole & all the fixings",
    image: FOOD_PHOTOS.tasteOfMexico,
    tag: "Serves 4",
    price: 2350,
    isVeg: false
  }
];

const SignatureDishesSection = () => {
  return (
    <section className="relative py-16 sm:py-20 paper-texture" data-testid="signature-dishes-section">
      <div className="zigzag-divider-green absolute top-0 left-0 right-0" />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-6">
        <div className="text-center mb-12">
          <div className="flex items-center justify-center gap-3 mb-3">
            <Star size={10} fill="#EE2535" stroke="none" />
            <ChefHat style={{ width: '32px', height: '32px', color: '#EE2535' }} />
            <Star size={10} fill="#EE2535" stroke="none" />
          </div>
          <h2
            className="font-display text-2xl sm:text-3xl lg:text-4xl mb-3"
            style={{ color: '#1A1918', textShadow: '2px 2px 0 rgba(238,37,53,0.12)' }}
            data-testid="signature-dishes-title"
          >
            New Mexican Restaurant in Hyderabad – Street-Style Tacos & Loaded Burritos
          </h2>
          <div className="zigzag-divider max-w-xs mx-auto mb-4" />
          <p className="font-mono text-[#4A4641] max-w-md mx-auto text-sm">
            Handpicked favorites from Chef John's kitchen — authentic Mexican, sized and spiced for India
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4">
          {signatureDishes.map((dish, idx) => (
            <div
              key={idx}
              className="group relative overflow-hidden transition-transform duration-300 hover:translate-x-[-2px] hover:translate-y-[-2px]"
              data-testid={`signature-dish-${idx}`}
              style={{ border: '3px solid #1A1918', boxShadow: '4px 4px 0 #1A1918' }}
            >
              <div className="aspect-square overflow-hidden">
                <img src={dish.image} alt={dish.name} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/20 to-transparent" />
              
              {/* Veg/Non-veg indicator */}
              <div className="absolute top-2 right-2 w-4 h-4 flex items-center justify-center" style={{ border: '1.5px solid white', backgroundColor: dish.isVeg ? '#51A262' : '#EE2535' }}>
                <div className="w-1.5 h-1.5 rounded-full bg-white" />
              </div>
              
              {/* Chef's Special badge */}
              <div className="absolute top-2 left-2">
                <span className="inline-flex items-center gap-1 text-[8px] font-mono font-bold px-1.5 py-0.5 uppercase tracking-wider" style={{ backgroundColor: '#F7B638', color: '#1A1918' }}>
                  <ChefHat size={8} /> Special
                </span>
              </div>

              <div className="absolute bottom-0 left-0 right-0 p-3 sm:p-4">
                <span
                  className="inline-block text-[10px] font-mono font-bold px-1.5 py-0.5 mb-1 uppercase tracking-wider"
                  style={{ backgroundColor: '#51A262', color: 'white' }}
                >
                  {dish.tag}
                </span>
                <h3 className="font-display text-sm sm:text-base lg:text-lg text-white leading-tight mb-1" style={{ textShadow: '1px 1px 0 rgba(0,0,0,0.5)' }}>
                  {dish.name}
                </h3>
                <p className="font-mono text-lg text-[#F7B638] font-bold">&nbsp;</p>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/food-menu"
            className="inline-flex items-center gap-3 px-8 py-4 font-display tracking-wider text-lg transition-transform hover:translate-x-[-2px] hover:translate-y-[-2px]"
            data-testid="view-full-food-menu-btn"
            style={{ backgroundColor: '#51A262', color: 'white', border: '3px solid #1A1918', boxShadow: '4px 4px 0 #1A1918' }}
          >
            VIEW FULL MENU <ArrowRight className="w-5 h-5" />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default SignatureDishesSection;